import { Search, X } from "lucide-react";
import { type ComponentProps, forwardRef, useEffect, useState } from "react";

import { Input } from "@/components/ui/input";
import useDebounce from "@/hooks/useDebounce";
import { cn } from "@/lib/utils";

const DataTableSearchInput = forwardRef<
  HTMLInputElement,
  Omit<ComponentProps<typeof Input>, "onChange"> & {
    onChange: (value?: string) => void;
    onExit?: () => void;
  }
>(({ className, value: _def, onExit, ...props }, ref) => {
  const [value, setValue] = useState("");
  const debouncedValue = useDebounce(value, 500);

  const handleKeyDown = (
    event: React.KeyboardEvent<HTMLInputElement>,
  ): void => {
    if (event.key === "Escape" && onExit) {
      onExit();
    }
  };

  useEffect(() => {
    props.onChange(debouncedValue?.trim() || "");
  }, [debouncedValue]);

  useEffect(() => {
    setValue((_def as string) || "");
  }, [_def]);

  return (
    <div className='relative'>
      <Input
        {...props}
        {...(props.autoFocus && { autoFocus: true })}
        ref={ref}
        onKeyDown={handleKeyDown}
        placeholder={props.placeholder || "Search"}
        icon={{
          icon: Search,
          position: "left",
        }}
        className={cn("h-9", onExit && "pr-10", className)}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        value={value}
      />
      {onExit && value && (
        <X
          onClick={onExit}
          className='absolute z-10 -translate-y-1/2 cursor-pointer size-4 top-1/2 right-3'
        />
      )}
    </div>
  );
});

DataTableSearchInput.displayName = "SearchInput";

export default DataTableSearchInput;
